import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, } from '@material-ui/core';
class CreateNotificationDialog extends React.Component {
    state = { 
        fields: { title: '', message: '', role: '', specificUser: '', users: [], url: '', } 
    };

    handleChange = event => {
        let fields = this.state.fields;
        const { type, name, value, checked } = event.target;
        fields[name] = type === 'checkbox' ? checked : value;
        this.setState({ fields });
    }

    componentDidMount() {
        let fields = this.state.fields;
        fields.url = window.location.href;
        this.setState({ fields });
    }

    handleRemove = index => {
        const { fields } = this.state;
        fields.users.splice(index, 1);
        this.setState({ fields });
    }

    handleAdd = () => {
        const { fields } = this.state;
        let user = {};
        user = { id: 0, userCode: fields.specificUser };
        fields.users.push(user);
        fields.specificUser = '';
        this.setState({ fields });
    }

    render() {
        const { open, handleClose, handleSubmit, Roles } = this.props;
        const { fields } = this.state;
        return (
            <Dialog open={open}
                // onClose={handleClose}
                // aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Create Notification</DialogTitle>
                <DialogContent dividers>
                    <label>
                        <Typography variant="caption" style={{ fontWeight: 500}}>Title</Typography>
                        <input type="text" value={fields.title ? fields.title : ''} name="title" onChange={this.handleChange} style={{ width: 320 }} />
                    </label>
                    <label>
                        <Typography variant="caption" style={{ fontWeight: 500}}>Message</Typography>
                        <textarea value={fields.message ? fields.message : ''} name='message' onChange={this.handleChange} style={{ width: 320, fontFamily: 'Roboto' }} rows="4" />
                    </label>
                    <label>
                        <Typography variant="caption" style={{ fontWeight: 500}}>Role</Typography>
                        <select value={fields.role ? fields.role : ''} name="role" onChange={this.handleChange} style={{ width: 320 }}>
                            <option value="">Select Role</option>
                            {
                                Roles && Roles.length ?
                                    Roles.map((r, id) => (<option key={id} value={r.roleId}>{r.roleName}</option>))
                                : null
                            }
                        </select>
                    </label>
                    <label>
                        <div style={{ display: 'flex' }}>
                            <div>
                                <Typography variant="caption" style={{ fontWeight: 500}}>Specific User</Typography>
                                <select value={fields.specificUser ? fields.specificUser : ''} name="specificUser" onChange={this.handleChange} style={{ width: 220 }}>
                                    <option value="">Select User</option>
                                </select>
                            </div>
                            <div style={{ margin: 8, marginLeft: 14 }}>
                                <Button size="small" disabled={fields.specificUser === ''} color="primary" variant="contained">Add</Button>
                            </div>
                        </div>
                        {
                            fields.users && fields.users.length > 0 ?
                            fields.users.map((u, id) => (
                                <div key={id} style={{ display: 'flex' }}>
                                    <Typography variant="caption">{u.userCode}</Typography>
                                    <Button size="small" variant="contained" color="secondary" onClick={() => this.handleRemove(id)}>Remove</Button>
                                </div>
                            ))
                            : null
                        }
                    </label>
                    <label>
                        <Typography variant="caption" style={{ fontWeight: 500}}>URL</Typography>
                        <input type="text" value={fields.url ? fields.url : ''} name="url" onChange={this.handleChange} style={{ width: 320 }} />
                    </label>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="default" size='small'>cancel</Button>
                    <Button onClick={() => handleSubmit(fields)} color="primary" size='small' autoFocus>submit</Button>
                </DialogActions>
            </Dialog>
        )
    }
}
export default CreateNotificationDialog